import DOMPurify from 'dompurify';

// 서식 에디터(Quill)로 저장된 기존 답변은 모두 <p>로 시작한다
const LEGACY_HTML = /^\s*<p>/i;

// HTML로 저장된 기존 답변을 일반 텍스트로 변환한다. 줄바꿈(<br>, 문단 끝)은 \n으로 남긴다.
// 일반 텍스트 답변(<햄릿> 같은 꺾쇠 포함)은 그대로 둔다.
export const htmlToText = (html: string): string => {
  if (!LEGACY_HTML.test(html)) return html;
  const withBreaks = html.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h[1-6])>/gi, '\n');
  const text = new DOMParser().parseFromString(withBreaks, 'text/html').body.textContent || '';
  return text.replace(/\n{3,}/g, '\n\n').trim();
};

// 글쓰기 에디터의 동영상 삽입(iframe)은 유튜브·비메오 주소만 허용한다
const ALLOWED_IFRAME_SRC = /^https:\/\/(www\.youtube\.com\/embed\/|player\.vimeo\.com\/video\/)/;

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (
    data.tagName === 'iframe' &&
    !ALLOWED_IFRAME_SRC.test((node as Element).getAttribute('src') || '')
  ) {
    node.parentNode?.removeChild(node);
  }
});

DOMPurify.addHook('afterSanitizeAttributes', node => {
  const el = node as HTMLElement;
  // 화면 전체를 덮는 오버레이(피싱)를 막기 위해 위치 지정 스타일은 제거한다 (글자색 등은 유지)
  if (el.style?.position) {
    el.style.removeProperty('position');
    if (!el.getAttribute('style')) el.removeAttribute('style');
  }
  // 새 탭 링크는 원래 페이지에 접근하지 못하게 한다
  if (el.tagName === 'A' && el.getAttribute('target') === '_blank') {
    el.setAttribute('rel', 'noopener noreferrer');
  }
});

// 사용자가 작성한 HTML에서 스크립트·이벤트 핸들러·입력 폼 등 위험한 요소를 제거한다.
export const sanitizeHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allowfullscreen', 'frameborder', 'target'],
    FORBID_TAGS: ['form', 'input', 'button', 'textarea', 'select', 'style'],
  });
